import React from 'react';

export const PublishContentContext = React.createContext<boolean>(false);
